import * as classnames from "classnames";

import { SupportedProgrammingLanguagesLink } from "@components/user/modals/partials/SupportedProgrammingLanguagesLink";

import {
  Form,
  FormGroup,
  Icon,
  JumpTo,
  Msg,
  Select,
  SelectItem,
} from "@shared/components";
import { ApplicantChallengeModel } from "@shared/models";
import { ProgrammingLanguage } from "@shared/services/enums";
import Message from "@shared/services/message";

export type ProgrammingLanguagePanelProps = {
  challenge: ApplicantChallengeModel;
  initialValue: ProgrammingLanguage | undefined;
  onChange: (programmingLanguage: ProgrammingLanguage) => void;
};

export const ProgrammingLanguagePanel = ({
  initialValue,
  challenge,
  onChange,
}: ProgrammingLanguagePanelProps) => {
  const options = challenge.programmingLanguages.map((item) => {
    return {
      label: ProgrammingLanguage.toString(item),
      value: item,
    } as SelectItem;
  });

  const rootStyle = classnames("code-programming-language-panel");

  const onFormChange = (
    formValid: boolean,
    formValues: { programmingLanguage: ProgrammingLanguage },
  ) => {
    onChange(formValues.programmingLanguage);
  };

  return (
    <div className={rootStyle}>
      <div>
        <Msg
          id="start-challenge.step3.text"
          values={{
            cog: <Icon type="cog" />,
            a: (chunks: string) => (
              <JumpTo to={Message.getMessageByKey("start-challenge.step3.url")}>
                {chunks}
              </JumpTo>
            ),
          }}
        />
      </div>
      <SupportedProgrammingLanguagesLink />
      <Form
        className="code-programming-language-panel__form"
        validation={{
          programmingLanguage: ["required"],
        }}
        initialValues={{
          programmingLanguage: initialValue,
        }}
        onFormChange={onFormChange}
      >
        <FormGroup>
          <Select
            name="programmingLanguage"
            innerClassName="is-medium"
            options={options}
          />
        </FormGroup>
      </Form>
    </div>
  );
};
